import { render, staticRenderFns } from "./AccountOrderMail.vue?vue&type=template&id=b229abe4&"
import script from "./AccountOrderMail.vue?vue&type=script&lang=js&"
export * from "./AccountOrderMail.vue?vue&type=script&lang=js&"
import style0 from "./AccountOrderMail.vue?vue&type=style&index=0&id=b229abe4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports